import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import PortfolioGrid from "@/components/PortfolioGrid";

const Portfolio = () => (
  <>
    <section className="relative pt-40 pb-12 md:pt-52 md:pb-16 border-b border-white/5" data-testid="portfolio-hero">
      <div className="max-w-[1480px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="font-mono-tech text-[11px] tracking-[0.22em] uppercase text-[var(--gold)] mb-6">
            <span className="text-white/35 mr-3">P / 00</span>Archive
          </div>
          <h1 className="font-display text-6xl md:text-[8vw] leading-[0.92] tracking-[-0.03em] text-white">
            The <span className="font-serif-display text-[var(--gold)]">archive</span>.
          </h1>
          <p className="mt-8 max-w-2xl text-white/65 text-lg leading-relaxed">
            Recent frames from every night we’ve worked. Tap any photo to open the lightbox.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="py-20 md:py-28">
      <div className="max-w-[1480px] mx-auto px-6 md:px-10">
        <PortfolioGrid />
      </div>
    </section>

    <section className="py-20 border-t border-white/5">
      <div className="max-w-[1480px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
        <h3 className="font-display text-3xl md:text-5xl text-white tracking-tight max-w-2xl">
          Book Lucra for your <span className="font-serif-display text-[var(--gold)]">next night</span>.
        </h3>
        <Link to="/contact" className="btn-gold" data-testid="portfolio-cta"><span>Inquire</span><ArrowUpRight size={14} /></Link>
      </div>
    </section>
  </>
);

export default Portfolio;
